import { createContext } from "react";

const LeaderBoardContext = createContext(undefined as any);

export default LeaderBoardContext;
